import React from 'react';
import { FadeIn } from './FadeIn';
export function BenefitsTimeline() {
  const benefits = [{
    time: 'En la primera semana',
    desc: 'Tu bebé empieza a reconocer la rutina de pre-sueño. El llanto al acostar dura menos. Hay una noche — solo una al principio — con un tramo de sueño 30 minutos más largo que el habitual. Y sientes algo que no sentías desde hace semanas: la posibilidad de que esto mejore.'
  }, {
    time: 'En el primer mes',
    desc: 'Las siestas se vuelven más predecibles. Los despertares nocturnos empiezan a reducirse de 4 o 5 a 2 o 3. Empiezas a tener bloques de sueño de 3 a 4 horas. Empiezas a tomar decisiones sin la niebla mental del agotamiento extremo.'
  }, {
    time: 'A los 2 o 3 meses',
    desc: 'Tu bebé duerme su primer tramo de 5 a 6 horas. Y tú te despiertas antes de que él llame — no porque él te llame sino porque tu cuerpo ya descansó lo suficiente para tener un ciclo de sueño completo por primera vez en meses.'
  }];
  return <section className="bg-white py-24 px-6" data-id="element-30">
      <div className="max-w-5xl mx-auto" data-id="element-31">
        <FadeIn data-id="element-32">
          <div className="text-center mb-16" data-id="element-33">
            <h2 className="text-3xl md:text-4xl font-bold text-azul-noche mb-4" data-id="element-34">
              Esto es lo que cambia cuando aplicas el sistema
            </h2>
            <p className="text-xl text-texto" data-id="element-35">
              No vamos a decirte lo que hace el libro.
              <br data-id="element-36" />
              Vamos a decirte lo que pasa en tu vida real cuando lo aplicas:
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-37">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={0.2 + index * 0.2} className="h-full" data-id="element-38">
              <div className="bg-white border border-lila-suave rounded-2xl p-8 shadow-md hover:shadow-xl transition-shadow h-full flex flex-col relative overflow-hidden" data-id="element-39">
                <div className="absolute top-0 left-0 w-full h-2 bg-lila-suave" data-id="element-40"></div>
                <div className="bg-crema w-12 h-12 rounded-full flex items-center justify-center mb-6" data-id="element-41">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1B2A4A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-42">
                    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" data-id="element-43" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-azul-noche mb-4" data-id="element-44">
                  {benefit.time}
                </h3>
                <p className="text-texto flex-grow" data-id="element-45">{benefit.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.8} data-id="element-46">
          <div className="text-center max-w-2xl mx-auto" data-id="element-47">
            <p className="text-2xl font-serif text-azul-noche italic" data-id="element-48">
              Ese momento existe. Y esta guía es el camino más corto para llegar
              a él.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}